// @ts-nocheck
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';
import styles from './actionMenu.module.css';
import AtomButton from '../../atoms/Button';

export interface MenuItemType {
  label: string;
  onClick: (row: any) => void;
  disabled?: boolean;
  icon?: React.ReactNode;
}

interface ActionMenuProps {
  /**
   * Array of menu items with their actions
   */
  menuItems: MenuItemType[];
  /**
   * Row data to be passed to the onClick handlers
   */
  rowData: any;
  /**
   * ID of the current row for managing multiple menus
   */
  rowId: string | number;
  /**
   * Optional className for styling
   */
  className?: string;
  /**
   * Optional custom button class
   */
  buttonClassName?: string;
  /**
   * Optional custom icon component
   */
  actionIcon?: React.ReactNode;
  /**
   * Optional disabled state
   */
  disabled?: boolean;
  /**
   * Optional callback when menu opens
   */
  onMenuOpen?: () => void;
  /**
   * Optional callback when menu closes
   */
  onMenuClose?: () => void;
}

const OrgActionMenu: React.FC<ActionMenuProps> = ({
  menuItems,
  rowData,
  rowId,
  className,
  buttonClassName,
  actionIcon = <MoreVertIcon />,
  disabled = false,
  onMenuOpen,
  onMenuClose,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openMenuId, setOpenMenuId] = React.useState<string | number | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpenMenuId(rowId);
    onMenuOpen?.();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenuId(null);
    onMenuClose?.();
  };

  const handleMenuItemClick = (item: MenuItemType) => {
    console.log("Menu item clicked:", item.label);
    console.log("Row data:", rowData);
    console.log("onClick function:", item.onClick);
    item.onClick(rowData);
    handleClose();
  };

  const open = Boolean(anchorEl) && openMenuId === rowId;

  return (
    <div className={`${styles.actionMenuContainer} ${className || ''}`}>
      <AtomButton
        variant="text"
        iconOnly={true}
        className={`${styles.actionButton} ${buttonClassName || ''}`}
        onClick={handleClick}
        disabled={disabled}
      >
        {actionIcon}
      </AtomButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        className={styles.menu}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleMenuItemClick(item)}
            disabled={item.disabled}
            className={styles.menuItem}
          >
            {item.icon && <span className={styles.menuItemIcon}>{item.icon}</span>}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default OrgActionMenu;
